import StaticContentService from "../../services/StaticContentService";

export interface Lov {
  id: string;
  name: string;
  code: string;
  group: string;
  value: any;
  updatedDate: number;
}

class StaticContentStore {
  staticContentService: StaticContentService;

  constructor() {
    this.staticContentService = new StaticContentService();
  }

  fetchStaticContent(
    key: string,
    language: string
  ): Promise<{ content: string } | null> {
    return this.staticContentService.getStaticContent(key, language);
  }

  updateStaticContent(
    key: string,
    language: string,
    content: string
  ): Promise<void> {
    return this.staticContentService.updateStaticContent(key, language, {
      content,
    });
  }
}

export default StaticContentStore;
